<template>
  <div class="vcl-logon-error">
    <div class="vcl-logon__rounded-icon">
      <vp-icon icon="exclamation-mark" class="rounded-icon__email" />
    </div>
    <h3 class="vcl-logon__title">{{ $t('errorLoggingIn') }}</h3>
    <p class="vcl-logon__description vcl-logon__description--center">{{ $t('thereWasAnErrorLoggingIn') }} {{ $t('ifYouNeedHelpPleaseClick') }} <a class="vcl-logon__link" :href="supportArticleLink">{{ $t('here') }}</a> {{ $t('orContactUsAt') }} <a v-bind:href="'mailto:' + supportEmail" class="vcl-logon__link">{{ supportEmail }}</a>.</p>
    <vp-button class="vcl-logon__button primary large" :styles="buttonStyles" @click="$router.push('/logon')">
      {{ $t('tryAgain') }}
    </vp-button>
  </div>
</template>

<script>
// General Components
import VpIcon from '../../components/vp-icon/VpIcon.vue';
import VpButton from '../../components/vp-button/VpButton.vue';

export default {
  name: 'VpLogonError',
  components: {
    VpIcon,
    VpButton,
  },
  inject: ['$busy'],
  props: {
    styles: {
      type: Object,
      default() {
        return {};
      },
    }
  },
  data: () => ({
    message: '',
    supportEmail: '',
    supportArticleLink: '',
  }),
  computed: {
    buttonStyles() {
      return this.styles.button || {};
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const byodConfig = JSON.parse(localStorage.getItem('proByodConfig')) || {};
      const { supportEmail: providerSupportEmail } = byodConfig;
      this.supportArticleLink = 'https://support.virtual-peaker.com/knowledge/error-logging-in';


      switch (this.app) {
        case 'gravity':
          this.supportEmail = 'gravity-connect@virtualpeaker.io';
          break;
        case 'home':
          this.supportEmail = providerSupportEmail ? providerSupportEmail : 'support@virtual-peaker.com';
          this.supportArticleLink = 'https://support.virtual-peaker.com/knowledge/homeowner-application-logging-in';
          break;
        default:
          this.supportEmail = 'support@virtual-peaker.com';
          break;
      }
      const { message } = this.$route.query;
      if (message) {
        this.message = message;
      }
      this.$busy.on(false);
    }
  }
};
</script>

<style lang="scss">
@import "../../styles/mixins.scss";

.vcl-logon-error {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 34px 30px 0px;
  .vcl-logon__rounded-icon {
    margin-bottom: 0px !important;
  }
  .vcl-logon__description {
    margin-bottom: 20px !important;
  }
  @include Tablet {
    padding: 55px 47px 55px;
    .vcl-logon__rounded-icon {
      margin-bottom: 10px !important;
    }
    .vcl-logon__description {
      margin-bottom: 37px !important;
    }
  }
}
</style>
